import { UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import GlobalConfig from './../api/GlobalConfig';

const authority = GlobalConfig.val().IdentityApiUrl;
const websiteUrl = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ''
}`;

let subdomain = window.location.hostname.split('.')[0];
if (subdomain === window.location.hostname) {
  subdomain = '';
} else {
  subdomain = subdomain + '-';
}

const clientId = () => {
  const code = GlobalConfig.val().Code;
  const client = 'mypage-app';

  if (code) {
    return `${code}-${client}`;
  }

  let subdomain = window.location.hostname.split('.')[0];
  if (subdomain === window.location.hostname) {
    subdomain = '';
  } else {
    subdomain = subdomain + '-';
  }

  return `${subdomain}${client}`;
};

const userManagerSettings: UserManagerSettings = {
  authority: authority,
  client_id: clientId(),
  filterProtocolClaims: true,
  loadUserInfo: false,
  silent_redirect_uri: `${websiteUrl}/silent-renew`,
  post_logout_redirect_uri: `${websiteUrl}/`,
  redirect_uri: `${websiteUrl}/callback`,
  response_type: 'code',
  scope: 'openid profile mypage-api',
  automaticSilentRenew: true,
  monitorSession: GlobalConfig.val().MonitorIdentitySession,
};

// Singleton instance
let userManagerInstance: UserManager | null = null;

const getUserManager = (): UserManager => {
  if (!userManagerInstance) {
    userManagerInstance = new UserManager({
      ...userManagerSettings,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
    });
  }
  return userManagerInstance;
};

const getUserManagerWithSettings = (settings: Partial<UserManagerSettings> = {}): UserManager => {
  // Merge provided settings with the default userManagerSettings.
  const merged: UserManagerSettings = {
    ...userManagerSettings,
    ...(settings as UserManagerSettings),
  };

  userManagerInstance = new UserManager({
    ...merged,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  });

  return userManagerInstance;
};

// Export an object so callers can use UserManagerService.getUserManager()
const UserManagerService = {
  get userManager(): UserManager {
    return getUserManager();
  },
  getUserManagerWithSettings,
};

export default UserManagerService;
